import { TypedUseSelectorHook } from "react-redux";

import { ChecklistDocument } from "../lib/model/editorState";
import { LibraryEntry } from "../lib/model/library";
import { editorEntry } from "../lib/state/editor";
import { ReduxState } from "../lib/state/store";

import { useAppState } from "./useAppState";

export const useEditorState = <T,>(stateFn: (libraryEntry: LibraryEntry) => T) => {
  return useAppState((state) => {
    const editingEntry = editorEntry(state.library);
    if (!editingEntry) {
      return null;
    }
    return stateFn(editingEntry);
  });
};

export const useCurrentEditorDocument = <T, U>(
  stateFn: (checklistDocument: ChecklistDocument) => T,
  defaultValue: U
) => {
  return useEditorState((state) => stateFn(state.present)) ?? defaultValue;
};

export const useLibraryState: TypedUseSelectorHook<ReduxState["library"]> = (stateFn) => {
  return useAppState((state) => stateFn(state.library));
};
